import { Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { WidgetInfo } from 'src/app/interfaces/widget-info';

@Directive({
  selector: '[appWidgetContainer]',
  standalone: false
})
export class WidgetContainerDirective implements OnInit {
  @Input() widgetInfo!: WidgetInfo;

  @Input() CompanyId?: number;
  @Input() VendorId?: number;

  constructor(public viewContainerRef: ViewContainerRef) {}

  ngOnInit(): void {
    const widgetReference = this.viewContainerRef.createComponent(
      this.widgetInfo.componentType
    );
    const { instance } = widgetReference;

    if (this.CompanyId) {
      Object.assign(instance, { CompanyId: this.CompanyId });
    }
    if (this.VendorId) {
      Object.assign(instance, { VendorId: this.VendorId });
    }
    // Assign any initialization/input data to the widget instance.
    if (this.widgetInfo.data) {
      Object.assign(instance, this.widgetInfo.data);
    }
    Object.assign(instance, { widgetInfo: this.widgetInfo });
  }
}
